document.addEventListener('scroll', function () {
    const backToTop = document.getElementById('back-to-top');
    const scrollPosition = window.scrollY || document.documentElement.scrollTop;
  if(backToTop){
    if (scrollPosition > window.innerHeight) { // 第二屏开始显示
      backToTop.classList.remove('none');
    } else {
      backToTop.classList.add('none');
    }
  }
});
var $=jQuery;
$(function(){
    $('#back-to-top').click(function(){
        // console.log('点击回到顶部');
        $('html, body').animate({ scrollTop: 0 }, 600); // 600 毫秒动画时间
        return false;
    })
})
  